import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { ApplicationContext } from 'src/app/model';
import { GlobalStateService, UserContextPermissionRoleService } from 'src/app/services';

@Component({
  selector: 'app-unauthorized',
  imports: [CommonModule],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss'
})
export class UnauthorizedComponent implements OnInit {
  message: string | undefined;
  hasAccess: boolean | null = null;
  appContext: ApplicationContext | undefined;

  constructor(private globalStateService: GlobalStateService,
    private userContextPermissionRoleService: UserContextPermissionRoleService
  ) { }

  async ngOnInit() {
    try {
      this.appContext = await this.globalStateService.getWorkpaperContextData();
      const result = await firstValueFrom(this.userContextPermissionRoleService.loadAccessInfo(this.appContext));
      const accessInfo = this.userContextPermissionRoleService.hasAccess(result);
      this.hasAccess = accessInfo.hasAccess;
      if (!accessInfo.hasAccess) {
        this.message = accessInfo.message;
      }
    } catch (error) {
      console.error('UnauthorizedComponent: Error occurred while loading access info:', error);
      this.hasAccess = false;
      this.message = 'Unable to verify your access. Please contact support.';
    }
  }
}